export default __webpack_public_path__ + "static/media/product3.1d2f5e96.png";